// utils/calendarUtils.js

/* ===== Utilities ===== */
export const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
export const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
export const addDays = (d, n) => {
  const cp = new Date(d);
  cp.setDate(cp.getDate() + n);
  return cp;
};
export const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

/* ===== Default monthly KPIs ===== */
export const KPI_KEYS = ["PR/TR", "PP/TP", "LIC", "NL", "CF", "TL", "BIS", "BE"];
export const defaultKpis = KPI_KEYS.reduce((acc, k) => { 
  // PR/TR and PP/TP should default to "0/0" format
  acc[k] = (k === "PR/TR" || k === "PP/TP") ? "0/0" : 0; 
  return acc; 
}, {});

// Full day time slots - hourly only
export const timeSlots = [
  "12:00AM", "1:00AM", "2:00AM", "3:00AM", "4:00AM", "5:00AM",
  "6:00AM", "7:00AM", "8:00AM", "9:00AM", "10:00AM", "11:00AM",
  "12:00PM", "1:00PM", "2:00PM", "3:00PM", "4:00PM", "5:00PM",
  "6:00PM", "7:00PM", "8:00PM", "9:00PM", "10:00PM", "11:00PM"
];

// Function to parse time string and return [hours24, minutes]
export const parseTimeString = (timeStr) => {
  if (!timeStr) return [12, 0];
  const cleaned = timeStr.trim().toUpperCase();
  const match = cleaned.match(/(\d+):(\d+)\s*(AM|PM)/);
  if (match) {
    let hours = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    const period = match[3];
    
    // Convert to 24-hour format
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    
    return [hours, minutes];
  }
  return [12, 0];
};

// Function to normalize time for comparison
export const normalizeTimeFormat = (timeStr) => {
  if (!timeStr) return '';
  const cleaned = timeStr.trim().toUpperCase();
  const match = cleaned.match(/(\d+):(\d+)\s*(AM|PM)/);
  if (match) {
    return `${match[1]}:${match[2]}${match[3]}`;
  }
  return cleaned;
};

// Appointment types and quadrants
export const APPOINTMENT_TYPES = ["1&2", "3", "4", "5", "P", "Other"];
export const QUADRANTS = [
  "Urgent/Important",
  "Not Urgent/Important", 
  "Urgent/Not Important",
  "Not Urgent/Not Important"
];

// Quadrant colors - consistent across all views
export const QUADRANT_COLORS = {
  "Urgent/Important": {
    bg: "#ffe5e5",        // soft light red
    border: "#d83a3a",    // main red
    label: "1",
    color: "#ff6b6b"      // readable dark-red text
  },

  "Not Urgent/Important": {
    bg: "#e8fff4",        // mint green background
    border: "#1b8a4a",    // main green
    label: "2",
    color: "#4ade80"      // darker green text
  },

  "Urgent/Not Important": {
    bg: "#fff8e6",        // soft warm yellow
    border: "#b68409",    // main amber
    label: "3",
    color: "#fbbf24"      // darker amber text
  },

  "Not Urgent/Not Important": {
    bg: "#f3f4f6",        // soft neutral gray
    border: "#4b5563",    // main gray
    label: "4",
    color: "#9ca3af"      // darker gray text
  }
};


